import React, { useEffect, useState } from 'react';
import './preloader.css';
import logo from '../assets/logo.png';

const Preloader = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(() => setVisible(false), 1250);
    return () => window.clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div className="preloader" role="status" aria-live="polite" aria-label="Website loading">
      <div className="preloader-mark">
        <img src={logo} alt="Egypt International Exhibition logo" />
      </div>
      <div className="preloader-copy">
        <span>Egypt International Exhibition</span>
        <strong>Loading experience</strong>
      </div>
      <div className="preloader-bar" aria-hidden="true">
        <span />
      </div>
    </div>
  );
};

export default Preloader;
